import { render, staticRenderFns } from "./VendingFormGeneralInfo.vue?vue&type=template&id=98c877e4&scoped=true"
import script from "./VendingFormGeneralInfo.vue?vue&type=script&lang=js"
export * from "./VendingFormGeneralInfo.vue?vue&type=script&lang=js"
import style0 from "./VendingFormGeneralInfo.vue?vue&type=style&index=0&id=98c877e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c877e4",
  null
  
)

export default component.exports